import { render, staticRenderFns } from "./tank.vue?vue&type=template&id=eb58db7a&scoped=true&"
import script from "./tank.vue?vue&type=script&lang=js&"
export * from "./tank.vue?vue&type=script&lang=js&"
import style0 from "./tank.vue?vue&type=style&index=0&id=eb58db7a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb58db7a",
  null
  
)

export default component.exports